import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RiferimentoPRModalComponent } from './riferimento-pr-modal';

export const RiferimentoPRModalModule: string = ng
    .module('riferimento-pr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('riferimentoPRModalComponent', RiferimentoPRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/riferimento-pr-modal/riferimento-pr-modal.module.ts